import React from 'react';
import f from './Filters.module.css';
import { formatYmdForDisplay, getEventPeriods } from '../../utils/eventDates';
import { toggleValue } from '../../utils/dashboardFilters';

const describePeriods = (event) => {
  const periods = getEventPeriods(event);
  if (periods.length === 0) return 'Sin fechas registradas';
  return periods
    .map((period) => (period.from === period.to
      ? formatYmdForDisplay(period.from)
      : `${formatYmdForDisplay(period.from)} – ${formatYmdForDisplay(period.to)}`))
    .join(' · ');
};

/* Filtro global de eventos (selección múltiple). Reutiliza el catálogo del módulo de Eventos.
   «Usar fechas del evento» solo se aplica cuando el usuario lo pide; seleccionar un evento nunca cambia el rango. */
export default function EventFilter({ events, loading, error, onRetry, selectedIds, onChange, datesInfo, onUseEventDates, note }) {
  const selectedEvents = events.filter((event) => selectedIds.includes(event.id));
  const summary = selectedEvents.length === 0
    ? 'Todos (con y sin evento)'
    : selectedEvents.length === 1 ? selectedEvents[0].name : `${selectedEvents.length} eventos`;
  const canUseDates = Boolean(datesInfo && datesInfo.range);

  return (
    <div className={f.field} data-testid="event-filter" data-tour="event-filter">
      <span className={f.label}>Eventos</span>

      {loading && <span className={f.hint} role="status">Cargando eventos…</span>}

      {!loading && error && (
        <div className={f.error} role="alert">
          <span>{error}</span>
          <button type="button" className={f.linkBtn} onClick={onRetry}>Reintentar</button>
        </div>
      )}

      {!loading && !error && events.length === 0 && <span className={f.hint}>La empresa no tiene eventos.</span>}

      {events.length > 0 && (
        <details className={f.menu}>
          <summary>{summary}</summary>
          <div className={f.menuPanel} role="group" aria-label="Eventos">
            <button type="button" className={f.linkBtn} onClick={() => onChange([])} disabled={selectedIds.length === 0}>
              Quitar selección
            </button>
            {events.map((event) => (
              <label key={event.id} className={f.option}>
                <input
                  type="checkbox"
                  checked={selectedIds.includes(event.id)}
                  onChange={() => onChange(toggleValue(selectedIds, event.id))}
                />
                <span>
                  <span className={f.optionName}>{event.name}</span>
                  <span className={f.optionDates}>{describePeriods(event)}</span>
                </span>
              </label>
            ))}
          </div>
        </details>
      )}

      {selectedEvents.length > 0 && (
        <>
          <span className={f.hint}>
            Con eventos seleccionados solo se cuentan las órdenes asociadas a ellos. Sin eventos seleccionados se incluyen todas.
          </span>
          <button
            type="button"
            className={f.actionBtn}
            disabled={!canUseDates}
            title={canUseDates ? undefined : 'Los eventos seleccionados no tienen fechas registradas'}
            onClick={onUseEventDates}
          >
            Usar fechas del evento
          </button>
        </>
      )}

      {note && <div className={note.kind === 'warn' ? f.warn : f.includes} role="status" data-testid="event-dates-note">{note.text}</div>}
    </div>
  );
}
